import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import img from '../img/dp.jpeg'
import '../style/navStyle.css'
import {motion} from 'framer-motion'

export default function Navbar() { 
    const click = () =>{
        if(window.innerWidth<770) {
            console.log(window.innerWidth)
            window.scrollTo(0, 990)
        }
    }

    return (
        <motion.div 
            initial={{opacity:0, y:"-100%"}} 
            animate={{opacity:1, y:0}} 
            exit={{opacity:0, y:"-100%"}} 
            transition={{type:"spring"}}
            className="navv col-lg-3 col-md-3 col-sm-3 col-xs-12"
            // style={{backgroundColor:bgColor}}
            >

            <img src={img} alt="profile img" className="img-circle img-responsive img-thumbnail" />
            <h1>Ritika Dey</h1>  
            <div className="navbar container-fluid">
                <li><Link to="/" onClick={click}>About</Link></li>
                <li><Link to="/skills" onClick={click}>Skills</Link></li>
                <li><Link to="/project" onClick={click}>Projects</Link></li>
                <li><Link to="/experience" onClick={click}>Experience</Link></li>
                <li><Link to="/contact" onClick={click}>Contact Me</Link></li> 
            </div>
{/* 
            <div className="d-inline-block"> 
               <input 
                  type="color" 
                  name="base" 
                  id="base" 
                  value="#0066cc"
                  onchange={(e) => setbgColor(e.target.value)} /> 
            </div> */}
        </motion.div>
    )
}
